import YouTube from "react-youtube";
import { YoutubeLinkProps } from "@repo/ui/src/types/youtubeLink";
import VideoMetadata from "@repo/ui/src/metadata/video-metadata";

interface Props extends YoutubeLinkProps {
  className?: string;
}
const YoutubeVideo = ({ youtubeId, className, ...rest }: Props) => {
  if (!youtubeId) {
    return null;
  }

  return (
    <>
      <VideoMetadata {...rest} />
      <YouTube
        videoId={youtubeId}
        opts={{
          height: "100%",
          width: "100%",
          playerVars: {
            controls: 1,
            showinfo: 0,
            rel: 0,
            modestbranding: 1,
            disablekb: 1,
            autoplay: 0,
            cc_load_policy: 1,
            enablejsapi: 1,
            iv_load_policy: 3,
            loop: 0,
          },
        }}
        onReady={(event: { target: { pauseVideo: () => any } }) =>
          event.target.pauseVideo()
        }
        className={className}
      />
    </>
  );
};

export default YoutubeVideo;
